import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';

@Entity()
export class ProductParticipationConfirmationLink extends AdornisEntity {
  static override _class = 'ProductParticipationConfirmationLink';

  @validate(nonOptional())
  @Field(type => String)
  productID!: string;

  @validate(nonOptional())
  @Field(type => String)
  url!: string;
}
